<template>
  <div class="indexPage" :style="{ height: menuHeight + 'px' }">
    <div style="display: flex; height: 100%">
      <el-scrollbar style="height: 100%">
        <el-menu
          default-active="1-0"
          :collapse="collapse"
          @select="onMenuSelect"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          style="border: none; max-width: 130px"
        >
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span slot="title">{{ $store.state.Counter.city }}</span>
            </template>
            <el-menu-item
              :index="'1-' + index"
              v-for="(item, index) in menulist"
              :key="index"
              >{{ dictionary[item].title }}</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <div style="flex-grow: 2; overflow: hidden">
        <div class="top-bar" id="top-bar">
          <div @click="collapse = !collapse" style="margin-left: 5px">
            <i class="el-icon-s-unfold" v-if="collapse"></i>
            <i class="el-icon-s-fold" v-else></i>
          </div>
          <div class="search-box">
            <input
              type="text"
              placeholder="回车搜索"
              @keyup.enter="search"
              v-model="searchText"
            />
          </div>
          <div class="search-box" v-if="currentModel === 'WpActivityModel'">
            <el-select
              v-model="activityPeopleType"
              placeholder="请选择活动参与人身份"
            >
              <el-option label="全部" value="全部"></el-option>
              <el-option label="置业顾问" value="置业顾问"></el-option>
              <el-option label="经纪人" value="经纪人"></el-option>
            </el-select>
          </div>
          <div v-if="isPhone">
            <el-row>
              <el-col>
                <el-dropdown trigger="click">
                  <el-button type="primary"
                    >菜单<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="onFlashClick"
                      >刷新</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="onAddClick"
                      >新增</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="onDeleteClick"
                      >删除</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="onModifyClick"
                      >修改</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="onBackClick"
                      >上页</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="onFrontClick"
                      >下页</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="onEditClick"
                      >编辑</el-dropdown-item
                    >

                    <el-dropdown-item
                      class="tool-item"
                      v-for="omenu in dictionary[currentModel].menus || []"
                      :key="omenu"
                      @click.native="onModelMenuClick(omenu)"
                      >{{ omenu }}</el-dropdown-item
                    >

                    <el-dropdown-item class="tool-items" @click.native="team()"
                      >返回首页</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
            </el-row>
          </div>

          <div
            v-else
            style="display: flex; overflow: hidden; flex-wrap: inherit"
          >
            <div class="tool-item" @click="onFlashClick">刷新</div>
            <div class="tool-item" @click="onAddClick">新增</div>
            <div class="tool-item" @click="onDeleteClick">删除</div>
            <div class="tool-item" @click="onModifyClick">修改</div>
            <div class="tool-item" @click="onBackClick">上页</div>
            <div class="tool-item" @click="onFrontClick">下页</div>
            <div
              class="tool-item"
              v-if="currentModel === 'WpActivityModel'"
              @click="drawActivityPoster()"
            >
              生成海报
            </div>
            <div class="tool-item" @click="onEditClick">编辑</div>

            <div
              class="tool-item"
              v-for="omenu in dictionary[currentModel].menus || []"
              :key="omenu"
              @click="onModelMenuClick(omenu)"
            >
              {{ omenu }}
            </div>

            <div class="tool-items" @click="team()">返回首页</div>
          </div>
          <div class="count" v-if="!isPhone" @click="noChoose">
            共{{ itemNum }}条&nbsp;第{{ page }}/{{
              Math.ceil(itemNum / 40)
            }}页&nbsp;选中{{ chooseNum }}
          </div>
        </div>
        <el-table
          :data="showdblist"
          :height="dataHeight"
          @selection-change="handleSelectionChange"
          @row-click="onRowClick"
          ref="multipleTable"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
          @cell-mouse-enter="cellMouseEnter"
          @cell-mouse-leave="cellMouseLeave"
          style="margin-top: 40px"
        >
          <el-table-column
            :prop="key"
            :label="value"
            v-for="(value, key) in menuitems[currentModel]"
            :key="key"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column type="selection" width="55"> </el-table-column>
        </el-table>
      </div>
    </div>

    <prompt
      :object="promptItem"
      @childOper="onChildOper"
      :style="{ display: ispromptshow ? 'block' : 'none' }"
    ></prompt>
    <confirm
      :option="confirmOption"
      @childOper="onChildOper"
      :style="{ display: isconfirmshow ? 'block' : 'none' }"
    >
    </confirm>

    <div class="image-background" v-if="spaceCode">
      <div class="image-preview">
        <span class="close" @click="spaceCode = null">关闭</span>
        <img :src="spaceCode" width="400px" height="400px" />
      </div>
    </div>
    <div class="image-background" v-if="activityPoster">
      <div class="image-preview">
        <span class="close" @click="activityPoster = null">关闭</span>
        <el-image
          :src="activityPoster"
          :style="{ width: '400px', height: '400px' }"
          :preview-src-list="[activityPoster]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DbMenu from "@/components/DbMenu";
import DataList from "@/components/DataList";
import prompt from "@/components/prompt";
import confirm from "@/components/confirm";

export default {
  components: {
    DbMenu,
    DataList,
    prompt,
    confirm,
  },
  data() {
    return {
      activityPoster: "",
      isviewshow: false,
      isdbshow: false,
      isapishow: false,
      ispromptshow: false,
      isconfirmshow: false,
      promptModel: "",
      promptItem: {},
      viewColor: "",
      apiColor: "",
      dbColor: "",
      filelist: [],
      apilist: [],
      dblist: [],
      showdblist: [],
      menulist: [],
      menuitems: {
        WpRealEstateModel: {
          id: "id",
          real_estate_name: "楼盘名",
          build_type: "类别",
          real_status: "状态",
          area_name: "板块",
          landDeal: "土拍",
          sun: "日照",
          hezuo: "合作",
        },
        WpRealEstateModel2: {
          id: "id",
          real_estate_name: "楼盘名",
          build_type: "类别",
          area_name: "板块",
          landDeal: "土拍",
          sun: "日照",
        },
        WpUserModel: {
          id: "id",
          open_id: "open_id",
          user_name: "用户名",
          user_type: "身份",
          phone: "电话",
          user_status: "状态",
          wk_userName: "微信id",
        },
        WpLocationModel: {
          id: "id",
          location_name: "名称",
          location_type: "类别",
          school_type: "子类",
          location_size: "规模",
          create_time: "创建时间",
        },
        WpAreaModel: {
          id: "id",
          area_name: "名称",
          hot: "热度排名",
          new_price: "新房价格",
          old_price: "二手价格",
        },
        WpAdModel: {
          id: "id",
          ad_url: "跳转",
          ad_name: "名称",
          type: "类别",
          status: "状态",
          create_time: "时间",
        },
        WpUpdateCheckModel: {
          id: "id",
          check_details: "详情",
          real_estate_id: "楼盘",
          key_word: "类别",
          user_id: "用户",
          check_status: "状态",
          create_time: "创建",
          update_time: "更新",
        },
        WpArticleModel: {
          id: "id",
          title: "标题",
          url: "链接",
          type: "类别",
          author: "作者",
          create_time: "时间",
          views_num: "浏览",
          top: "置顶",
        },
        WpBackupModel: {
          id: "id",
          name: "名称",
          create_time: "创建",
          update_time: "更新",
        },
        AreaPlanModel: {
          id: "id",
          name: "名称",
          area_id: "板块id",
          northeast: "东北角",
          southwest: "西南角",
          create_time: "时间",
        },
        SubwayModel: {
          id: "id",
          stage: "几期",
          name: "线路名",
          create_time: "创建",
          update_time: "更新",
        },
        HighwayModel: {
          id: "id",
          name: "名称",
          create_time: "创建",
          update_time: "更新",
        },
        WpSystemModel: {
          words: "文字",
          create_time: "时间",
        },
        WpActivityModel: {
          id: "id",
          type: "类别",
          words: "说明",
          deadline: "截止日期",
          sale_type: "活动参与人身份",
          limit: "上限",
        },
        LandDealModel: {
          id: "id",
          number: "编号",
          district: "区域",
          area_name: "板块",
          squareJ: "建筑面积",
          deal_price: "成交价",
          limitm: "毛坯限价",
          limitj: "精装限价",
          deal_date: "成交日期",
        },
        WpLabelModel: {
          second: "分组",
          name: "名称",
          type: "分类",
          show: "简称",
          sort: "排序",
        },
        WpCrlistModel: {
          id: "id",
          name: "集合名",
          hot: "点击量",
          create_time: "时间",
        },
        WpNoticeModel: {
          content: "内容",
          range: "范围",
          status: "状态",
          update_time: "时间",
        },
        WpQlartModel: {
          art_id: "文章id",
          create_time: "投放时间",
        },
        WpZhiboModel: {
          id: "id",
          title: "标题",
          room: "房间号",
          status: "状态",
          estate_id: "楼盘",
          start_time: "开始时间",
        },
        GeoChatModel: {
          name: "名称",
          city: "城市",
        },
        ProductModel: {
          title: "标题",
        },
        ShopModel: {
          id: "id",
          name: "店名",
        },
        WpSurveyModel: {
          id: "id",
          user_id: "发起人",
          words: "描述",
          views_num: "浏览量",
          create_time: "时间",
        },

        SzEstateModel: {
          id: "id",
          real_estate_name: "楼盘名",
          build_type: "类型",
          real_status: "状态",
          area_name: "板块",
          landDeal: "土拍",
          sun: "日照",
          piece: "价格",
        },
        SzAreaModel: {
          id: "id",
          area_name: "名称",
          level: "级别",
        },
        SzAdModel: {
          id: "id",
          ad_url: "跳转",
          ad_name: "名称",
          type: "类别",
          status: "状态",
          create_time: "时间",
        },
        SzBackupModel: {
          id: "id",
          name: "名称",
          create_time: "创建",
          update_time: "更新",
        },
        SzUserModel: {
          id: "id",
          open_id: "open_id",
          user_name: "用户名",
          user_type: "身份",
          phone: "电话",
          user_status: "状态",
          wk_userName: "微信id",
        },
        SzArticleModel: {
          id: "id",
          title: "标题",
          url: "链接",
          type: "类别",
          author: "作者",
          real_estate_id: "楼盘",
          create_time: "时间",
        },
        SzLocationModel: {
          id: "id",
          location_name: "名称",
          location_type: "类别",
          school_type: "子类",
          location_size: "规模",
          create_time: "创建时间",
        },
        SzSubwayModel: {
          id: "id",
          stage: "几期",
          name: "线路名",
          create_time: "创建",
          update_time: "更新",
        },
        SzLabelModel: {
          second: "分组",
          name: "名称",
          type: "分类",
          hits: "点击数",
          count: "楼盘数",
        },
        SzUpdateCheckModel: {
          id: "id",
          check_details: "详情",
          real_estate_id: "楼盘",
          key_word: "类别",
          user_id: "用户",
          check_status: "状态",
          create_time: "创建",
          update_time: "更新",
        },
        SzCrlistModel: {
          id: "id",
          name: "集合名",
          hot: "点击量",
          create_time: "时间",
        },
        SzAreaPlanModel: {
          name: "名称",
          area_id: "板块id",
          northeast: "东北角",
          southwest: "西南角",
          create_time: "时间",
        },
        SzLandDealModel: {
          id: "id",
          number: "编号",
          district: "区域",
          area_name: "板块",
          squareJ: "建筑面积",
          deal_price: "成交价",
          deal_date: "成交日期",
        },
        SzSystemModel: {
          words: "文字",
          create_time: "时间",
        },

        TjEstateModel: {
          id: "id",
          real_estate_name: "楼盘名",
          build_type: "类型",
          real_status: "状态",
          area_name: "板块",
          landDeal: "土拍",
          sun: "日照",
        },
        TjAreaModel: {
          id: "id",
          area_name: "名称",
          level: "级别",
        },
        TjAdModel: {
          id: "id",
          ad_url: "跳转",
          ad_name: "名称",
          type: "类别",
          status: "状态",
          create_time: "时间",
        },
        TjBackupModel: {
          id: "id",
          name: "名称",
          create_time: "创建",
          update_time: "更新",
        },
        TjUserModel: {
          id: "id",
          open_id: "open_id",
          user_name: "用户名",
          user_type: "身份",
          wk_userName: "微信id",
        },
        TjArticleModel: {
          id: "id",
          title: "标题",
          url: "链接",
          type: "类别",
          author: "作者",
          real_estate_id: "楼盘",
          create_time: "时间",
        },
        TjLocationModel: {
          id: "id",
          location_name: "名称",
          location_type: "类别",
          school_type: "子类",
          location_size: "规模",
          create_time: "创建时间",
        },
        TjSubwayModel: {
          id: "id",
          stage: "几期",
          name: "线路名",
          create_time: "创建",
          update_time: "更新",
        },
        TjLabelModel: {
          second: "分组",
          name: "名称",
          type: "分类",
          hits: "点击数",
          count: "楼盘数",
        },

        SxEstateModel: {
          id: "id",
          real_estate_name: "楼盘名",
          build_type: "类型",
          real_status: "状态",
          area_name: "板块",
          landDeal: "土拍",
          sun: "日照",
          piece: "价格",
        },
        SxAreaModel: {
          id: "id",
          area_name: "名称",
          level: "级别",
        },
        SxAdModel: {
          id: "id",
          ad_url: "跳转",
          ad_name: "名称",
          type: "类别",
          status: "状态",
          create_time: "时间",
        },
        SxBackupModel: {
          id: "id",
          name: "名称",
          create_time: "创建",
          update_time: "更新",
        },
        SxUserModel: {
          id: "id",
          open_id: "open_id",
          user_name: "用户名",
          user_type: "身份",
          wk_userName: "微信id",
        },
        SxArticleModel: {
          id: "id",
          title: "标题",
          url: "链接",
          type: "类别",
          author: "作者",
          real_estate_id: "楼盘",
          create_time: "时间",
        },
        SxLocationModel: {
          id: "id",
          location_name: "名称",
          location_type: "类别",
          school_type: "子类",
          location_size: "规模",
          create_time: "创建时间",
        },
        SxSubwayModel: {
          id: "id",
          stage: "几期",
          name: "线路名",
          create_time: "创建",
          update_time: "更新",
        },
        SxLabelModel: {
          second: "分组",
          name: "名称",
          type: "分类",
          hits: "点击数",
          count: "楼盘数",
        },
        SxUpdateCheckModel: {
          id: "id",
          check_details: "详情",
          real_estate_id: "楼盘",
          key_word: "类别",
          user_id: "用户",
          check_status: "状态",
          create_time: "创建",
          update_time: "更新",
        },

        NbEstateModel: {
          id: "id",
          real_estate_name: "楼盘名",
          build_type: "类型",
          real_status: "状态",
          area_name: "板块",
          landDeal: "土拍",
          sun: "日照",
          piece: "价格",
        },
        NbAreaModel: {
          id: "id",
          area_name: "名称",
          level: "级别",
        },
        NbAdModel: {
          id: "id",
          ad_url: "跳转",
          ad_name: "名称",
          type: "类别",
          status: "状态",
          create_time: "时间",
        },
        NbBackupModel: {
          id: "id",
          name: "名称",
          create_time: "创建",
          update_time: "更新",
        },
        NbUserModel: {
          id: "id",
          open_id: "open_id",
          user_name: "用户名",
          user_type: "身份",
          wk_userName: "微信id",
        },
        NbArticleModel: {
          id: "id",
          title: "标题",
          url: "链接",
          type: "类别",
          author: "作者",
          real_estate_id: "楼盘",
          create_time: "时间",
        },
        NbLocationModel: {
          id: "id",
          location_name: "名称",
          location_type: "类别",
          school_type: "子类",
          location_size: "规模",
          create_time: "创建时间",
        },
        NbSubwayModel: {
          id: "id",
          stage: "几期",
          name: "线路名",
          create_time: "创建",
          update_time: "更新",
        },
        NbLabelModel: {
          second: "分组",
          name: "名称",
          type: "分类",
          hits: "点击数",
          count: "楼盘数",
        },
        NbUpdateCheckModel: {
          id: "id",
          check_details: "详情",
          real_estate_id: "楼盘",
          key_word: "类别",
          user_id: "用户",
          check_status: "状态",
          create_time: "创建",
          update_time: "更新",
        },
      },
      page: 1,
      searchText: "",
      baseList: [],
      confirmOption: {},

      spaceCode: null,
      sortMap: {
        imageNum: false,
        wait: false,
        salerNum: false,
        views_num: false,
        yfx: false,
        yzl: false,
        tfx: false,
        tzl: false,
        ydz: false,
        tdz: false,
        article: false,
        active_num: false,
      },

      // pageList: ['页面导航', '入驻审核', '资料审核', '疫情标记', '更新检查',  '楼盘集合', '楼市提问', '地图菜单', '内容运营', '其它操作'],

      first: false,

      choosedItems: [],
      collapse: false,
      currentModel: "",
      activityPeopleType: "全部",
      dictionary: {
        WpRealEstateModel: {
          name: "real-estate",
          menus: [
            "附近",
            "等级",
            "公示",
            "图库",
            "详情",
            "预约码",
            "预计",
            "售罄",
            "复制",
            "地铁",
          ],
          title: "新房",
        },
        WpRealEstateModel2: {
          name: "real-estate",
          menus: ["附近", "等级", "图库", "详情", "次新"],
          title: "二手",
        },
        WpLocationModel: {
          name: "location",
          menus: ["画学区", "重点", "配套图", "规模"],
          title: "地段",
        },
        WpAreaModel: {
          name: "wp-area",
          menus: ["画板块", "更新地块"],
          title: "板块",
        },
        WpAdModel: {
          name: "ad",
          title: "广告",
        },
        WpUserModel: {
          menus: ["空间码", "消息", "详情", "清空活动"],
          title: "用户",
        },
        WpUpdateCheckModel: {
          title: "审核",
        },
        WpArticleModel: {
          name: "article",
          menus: ["扫码", "写文章", "投放群", "群截图", "置顶"],
          title: "文章",
        },
        WpBackupModel: {
          name: "backup",
          title: "备份",
        },
        AreaPlanModel: {
          name: "landPlan",
          menus: ["画地块"],
          title: "土规",
        },
        SubwayModel: {
          name: "subway",
          title: "地铁",
        },
        WpSystemModel: {
          name: "system",
          title: "系统",
        },
        WpActivityModel: {
          name: "activity",
          title: "活动",
        },
        LandDealModel: {
          name: "landDeal",
          menus: ["坐标", "限价", "开发商", "未建盘"],
          title: "土拍",
        },
        WpLabelModel: {
          title: "标签",
        },
        HighwayModel: {
          name: "highway",
          title: "高架",
        },
        WpCrlistModel: {
          menus: ["扫码"],
          title: "合集",
        },
        WpNoticeModel: {
          title: "群公告",
        },
        WpQlartModel: {
          title: "投放",
        },
        GeoChatModel: {
          name: "GeoChat",
          title: "全国群",
        },
        WpSurveyModel: {
          title: "投票",
        },
        WpZhiboModel: {
          name: "Zhibo",
          title: "直播",
        },
        ProductModel: {
          name: "Product",
          title: "商品",
        },
        ShopModel: {
          name: "Shop",
          title: "店铺",
        },

        SzEstateModel: {
          name: "real-estate",
          menus: ["附近", "等级", "公示", "图库", "详情", "价格"],
          title: "新房",
        },
        SzAreaModel: {
          name: "wp-area",
          menus: ["画板块"],
          title: "板块",
        },
        SzAdModel: {
          name: "ad",
          title: "广告",
        },
        SzBackupModel: {
          name: "backup",
          title: "备份",
        },
        SzUserModel: {
          menus: ["详情"],
          title: "用户",
        },
        SzArticleModel: {
          name: "article",
          menus: ["写文章"],
          title: "文章",
        },
        SzLocationModel: {
          name: "location",
          menus: ["画学区"],
          title: "地段",
        },
        SzSubwayModel: {
          name: "subway",
          title: "地铁",
        },
        SzLabelModel: {
          title: "标签",
        },
        SzUpdateCheckModel: {
          title: "审核",
        },
        SzCrlistModel: {
          title: "合集",
        },
        SzAreaPlanModel: {
          name: "landPlan",
          menus: ["画地块"],
          title: "土规",
        },
        SzLandDealModel: {
          name: "landDeal",
          title: "土拍",
        },
        SzSystemModel: {
          name: "system",
          title: "系统",
        },

        TjEstateModel: {
          name: "real-estate",
          menus: ["附近", "公示", "图库", "详情"],
          title: "新房",
        },
        TjAreaModel: {
          name: "wp-area",
          menus: ["画板块"],
          title: "板块",
        },
        TjAdModel: {
          name: "ad",
          title: "广告",
        },
        TjBackupModel: {
          name: "backup",
          title: "备份",
        },
        TjUserModel: {
          title: "用户",
        },
        TjArticleModel: {
          name: "article",
          title: "文章",
        },
        TjLocationModel: {
          name: "location",
          title: "地段",
        },
        TjSubwayModel: {
          name: "subway",
          title: "地铁",
        },
        TjLabelModel: {
          title: "标签",
        },

        SxEstateModel: {
          name: "real-estate",
          menus: ["附近", "等级", "公示", "图库", "详情", "价格"],
          title: "新房",
        },
        SxAreaModel: {
          name: "wp-area",
          menus: ["画板块"],
          title: "板块",
        },
        SxAdModel: {
          name: "ad",
          title: "广告",
        },
        SxBackupModel: {
          name: "backup",
          title: "备份",
        },
        SxUserModel: {
          title: "用户",
        },
        SxArticleModel: {
          name: "article",
          menus: ["写文章"],
          title: "文章",
        },
        SxLocationModel: {
          name: "location",
          title: "地段",
        },
        SxSubwayModel: {
          name: "subway",
          title: "地铁",
        },
        SxLabelModel: {
          title: "标签",
        },
        SxUpdateCheckModel: {
          title: "审核",
        },

        NbEstateModel: {
          name: "real-estate",
          menus: ["附近", "等级", "公示", "图库", "详情", "价格"],
          title: "新房",
        },
        NbAreaModel: {
          name: "wp-area",
          menus: ["画板块"],
          title: "板块",
        },
        NbAdModel: {
          name: "ad",
          title: "广告",
        },
        NbBackupModel: {
          name: "backup",
          title: "备份",
        },
        NbUserModel: {
          title: "用户",
        },
        NbArticleModel: {
          name: "article",
          menus: ["写文章"],
          title: "文章",
        },
        NbLocationModel: {
          name: "location",
          title: "地段",
        },
        NbSubwayModel: {
          name: "subway",
          title: "地铁",
        },
        NbLabelModel: {
          title: "标签",
        },
        NbUpdateCheckModel: {
          title: "审核",
        },
      },
      dataHeight: 500,
      isPhone: false,
      gmCheck: false,
    };
  },
  created() {
    this.first = true;
    this.dataHeight = window.innerHeight - 39;
    this.menuHeight = window.innerHeight;

    let menuMap = {
      杭州: [
        "WpRealEstateModel",
        "WpRealEstateModel2",
        "WpLocationModel",
        "WpAreaModel",
        "WpAdModel",
        "WpUserModel",
        "WpUpdateCheckModel",
        "WpArticleModel",
        "WpBackupModel",
        "AreaPlanModel",
        "SubwayModel",
        "WpSystemModel",
        "WpActivityModel",
        "LandDealModel",
        "WpLabelModel",
        "HighwayModel",
        "WpCrlistModel",
        "WpNoticeModel",
        "WpQlartModel",
        "WpZhiboModel",
        "GeoChatModel",
        "ProductModel",
        "ShopModel",
        "WpSurveyModel",
      ],
      苏州: [
        "SzEstateModel",
        "SzAreaModel",
        "SzAdModel",
        "SzBackupModel",
        "SzUserModel",
        "SzArticleModel",
        "SzLocationModel",
        "SzSubwayModel",
        "SzLabelModel",
        "SzUpdateCheckModel",
        "SzCrlistModel",
        "SzAreaPlanModel",
        "SzLandDealModel",
        "SzSystemModel",
      ],
      天津: [
        "TjEstateModel",
        "TjAreaModel",
        "TjAdModel",
        "TjBackupModel",
        "TjUserModel",
        "TjArticleModel",
        "TjLocationModel",
        "TjSubwayModel",
        "TjLabelModel",
      ],
      绍兴: [
        "SxEstateModel",
        "SxAreaModel",
        "SxAdModel",
        "SxBackupModel",
        "SxUserModel",
        "SxArticleModel",
        "SxLocationModel",
        "SxSubwayModel",
        "SxLabelModel",
        "SxUpdateCheckModel",
      ],
      宁波: [
        "NbEstateModel",
        "NbAreaModel",
        "NbAdModel",
        "NbBackupModel",
        "NbUserModel",
        "NbArticleModel",
        "NbLocationModel",
        "NbSubwayModel",
        "NbLabelModel",
        "NbUpdateCheckModel",
      ],
    };
    let user_type = sessionStorage.getItem("identity") || "";
    let mlist = [];
    if (user_type === "系统管理员" || user_type.includes("数据列表")) {
      mlist = menuMap[this.$store.state.Counter.city];
    } else if (user_type.includes("广告")) {
      mlist = ["WpAdModel"];
    }
    if (!user_type.includes("广告") && user_type !== "系统管理员") {
      mlist = mlist.filter((x) => x !== "WpAdModel");
    }
    this.menulist = mlist;
    this.currentModel = mlist[0] || "";
  },
  activated() {
    if (!this.first) {
      this.$close();
    } else {
      this.first = false;
    }
  },
  mounted() {
    let that = this;
    this.init();
    let pp = navigator.userAgent;
    console.log("pp", pp);
    if (pp.includes("Mobile")) {
      // 这是移动端
      that.isPhone = true;
      this.menuitems["WpRealEstateModel"] = {
        real_estate_name: "楼盘名",
      };
    }
    window.onresize = () => {
      that.dataHeight = window.innerHeight - 39;
      that.menuHeight = window.innerHeight;
    };
    window.onpopstate = () => {
      this.$close();
    };
  },
  computed: {
    itemNum() {
      return this.baseList.length;
    },
    chooseNum() {
      return this.choosedItems.length;
    },
  },
  watch: {
    activityPeopleType(newVal) {
      this.search();
    },
  },
  methods: {
    init() {
      let that = this;
      let model = that.currentModel;
      if (model) {
        that.$open();
        let data = {
          dataContent: model,
        };
        that.$axios
          .get(that.$url_prefix + "getDataByModel", {
            params: data,
          })
          .then(function (res) {
            console.log(model, res.data.data);
            let tempList = res.data.data;
            that.dblist = tempList;
            that.baseList = JSON.parse(JSON.stringify(tempList));
            that.showdblist = JSON.parse(JSON.stringify(tempList)).slice(
              (that.page - 1) * 40,
              that.page * 40
            );
            that.$close();
          })
          .catch(function (res) {
            console.log(res);
            that.$close();
          });
      }
    },
    showSizedMarket() {
      let that = this;
      if (that.currentModel !== "WpLocationModel") {
        return;
      }
      that.baseList = that.dblist.filter(
        (x) => x.location_type === "商场" && x.location_size
      );
      that.showdblist = JSON.parse(JSON.stringify(that.baseList)).slice(
        (that.page - 1) * 40,
        that.page * 40
      );
    },
    onChildOper(data) {
      switch (data.from) {
        case "dropMenu":
          switch (data.oper) {
            case "click":
              this.onMenuClick(data);
              break;
          }
          break;
        case "prompt":
          switch (data.oper) {
            case "cancel":
              this.ispromptshow = false;
              break;
            case "submit":
              this.onPromptSubmit(data);
              break;
          }
          break;
        case "confirm":
          switch (data.to) {
            case "delete":
              switch (data.oper) {
                case "ok":
                  this.onConfirmOk();
                  break;
                case "cancel":
                  this.isconfirmshow = false;
                  break;
              }
              break;
            case "updateLabel":
              switch (data.oper) {
                case "ok":
                  this.updateAllLabel();
                  break;
                case "cancel":
                  this.isconfirmshow = false;
                  break;
              }
              break;
          }
          break;
        case "listItem":
          switch (data.oper) {
            case "sort":
              this.sortDataList(data.key);
              break;
          }
          break;
      }
    },
    onPromptSubmit(data) {
      this.ispromptshow = false;
      let thiz = this;
      console.log("data.item", data.item);
      this.$axios
        .post(thiz.$url_prefix + "updateData", {
          db: thiz.currentModel,
          model: thiz.promptModel,
          item: JSON.stringify(data.item),
          items: JSON.stringify(thiz.choosedItems),
        })
        .then(function (response) {
          thiz.onFlashClick();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onConfirmOk() {
      this.isconfirmshow = false;
      let thiz = this;
      this.$axios
        .post(thiz.$url_prefix + "delete", {
          db: thiz.currentModel,
          items: JSON.stringify(thiz.choosedItems),
        })
        .then(function (response) {
          if (response.data.success) {
            thiz.onFlashClick();
          } else {
            thiz.$message.error("删除失败，请联系管理员");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onFlashClick() {
      this.init();
    },
    search() {
      let filter = this.searchText;
      if (filter === "" || filter === null) {
        if (
          this.activityPeopleType === "全部" ||
          this.currentModel !== "WpActivityModel"
        ) {
          this.showdblist = this.dblist.slice(
            (this.page - 1) * 40,
            this.page * 40
          );
          this.baseList = this.dblist.slice(0);
        } else {
          this.page = 1;
          this.showdblist = [];
          this.baseList = [];
          for (let index in this.dblist) {
            for (let value in this.dblist[index]) {
              if (this.activityPeopleType === this.dblist[index].sale_type) {
                this.baseList.push(
                  JSON.parse(JSON.stringify(this.dblist[index]))
                );
                break;
              }
            }
          }
          this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(
            0,
            40
          );
        }
      } else {
        this.page = 1;
        this.showdblist = [];
        this.baseList = [];
        for (let index in this.dblist) {
          for (let value in this.dblist[index]) {
            if ((this.dblist[index][value] + " ").indexOf(filter) > -1) {
              if (
                this.activityPeopleType === "全部" ||
                this.currentModel !== "WpActivityModel"
              ) {
                this.baseList.push(
                  JSON.parse(JSON.stringify(this.dblist[index]))
                );
                break;
              } else if (
                this.activityPeopleType === this.dblist[index].sale_type
              ) {
                this.baseList.push(
                  JSON.parse(JSON.stringify(this.dblist[index]))
                );
                break;
              }
            }
          }
        }
        this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(
          0,
          40
        );
      }
    },
    findNoBaseInfo() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.dblist.filter((x) => !x.base_info);
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    findWaitCheckSell() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.dblist.filter((x) => x.sell);
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    findWaitCheckInfo() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.dblist.filter((x) => x.info);
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    findNoPrice() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.dblist.filter((x) => !x.piece || !x.piece.length);
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    findNoLnglat() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.baseList.filter((x) => !x.lnglat);
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    findNoLimitj() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.baseList.filter(
        (x) =>
          !x.deal_date.includes("-") &&
          !x.limitj &&
          x.purpose &&
          x.purpose.includes("住宅") &&
          !x.purpose.includes("租")
      );
      this.baseList.sort((a, b) => {
        let stra = a.deal_date
          .replace("年", "-")
          .replace("月", "-")
          .replace("日", "");
        let strb = b.deal_date
          .replace("年", "-")
          .replace("月", "-")
          .replace("日", "");
        return new Date(strb) - new Date(stra);
      });
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    findNoDevelop() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.baseList.filter(
        (x) =>
          x.limitj &&
          x.purpose &&
          x.purpose.includes("住宅") &&
          !x.purpose.includes("租") &&
          !x.estate_id &&
          x.owner &&
          !x.develop
      );
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    findNoEstate() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.baseList.filter(
        (x) =>
          !x.deal_date.includes("-") &&
          x.limitj &&
          x.purpose &&
          x.purpose.includes("住宅") &&
          !x.purpose.includes("租") &&
          !x.estate_id &&
          x.owner
      );
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    onAddClick() {
      let that = this;
      let jump = that.dictionary[that.currentModel];
      if (jump && jump.name) {
        that.$router.push({
          name: jump.name,
        });
      }
    },
    onDeleteClick() {
      if (this.choosedItems.length < 1) return;
      this.confirmOption = {
        title: "注意注意！",
        words: "尽量不要删数据，确认要删除吗？",
        okWord: "删除",
        cancleWord: "取消",
        to: "delete",
      };
      this.isconfirmshow = true;
    },
    onModifyClick() {
      if (this.choosedItems.length === 1) {
        let item = this.choosedItems[0];
        let temp = JSON.parse(
          JSON.stringify(this.menuitems[this.currentModel])
        );
        for (let key in temp) {
          temp[key] = "";
          if (item.hasOwnProperty(key)) {
            temp[key] = item[key];
          }
        }
        if (item["_id"]) {
          temp["_id"] = item["_id"];
        }

        this.promptItem = temp;
        this.promptModel = "edit";
        this.ispromptshow = true;
      }
    },

    onBackClick() {
      if (this.page > 1) {
        this.page--;
        this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(
          (this.page - 1) * 40,
          this.page * 40
        );
      }
    },
    onFrontClick() {
      if (this.page < this.baseList.length / 40) {
        this.page++;
        this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(
          (this.page - 1) * 40,
          this.page * 40
        );
      }
    },
    onEditClick() {
      let that = this;
      if (this.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        console.log("item", item);
        let jump = that.dictionary[that.currentModel];
        if (jump && jump.name) {
          this.$router.push({
            name: jump.name,
            params: item,
          });
        }
      }
    },
    toEditArticle() {
      if (this.choosedItems.length === 1) {
        let item = this.choosedItems[0];
        this.$router.push({
          name: "tinymce",
          params: item,
        });
      }
    },
    onNearbyClick() {
      let that = this;
      if (this.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        item.operation = "nearby";
        that.$router.push({
          name: "location",
          params: item,
        });
      } else {
        let item = { operation: "check" };
        that.$router.push({
          name: "location",
          params: item,
        });
      }
    },
    team() {
      this.$router.push({
        path: "/",
      });
    },
    onSaleInfoClick(type) {
      let that = this;
      let length = that.choosedItems.length;
      let item = {};
      if (length === 1) {
        item = that.choosedItems[0];
        item.type = type;
        that.$router.push({
          name: "saleInfo",
          params: item,
        });
      } else if (length === 0) {
        that.findWaitCheckSell();
      }
    },
    onInfoClick() {
      let that = this;
      let length = that.choosedItems.length;
      let item = {};
      if (length === 1) {
        item = that.choosedItems[0];
        item.type = "详情";
        that.$router.push({
          name: "saleInfo",
          params: item,
        });
      } else if (length === 0) {
        that.findWaitCheckInfo();
      }
    },
    getUser() {
      let that = this;
      if (that.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        that.$axios
          .get(that.$url_prefix + "queryUserInfo", {
            params: {
              user_id: item.id,
            },
          })
          .then(function (res) {
            console.log("queryUserInfo", res.data);
            console.log("楼盘 id", res.data.data && res.data.data.estates);
            console.log("加分明细", res.data.data && res.data.data.detail);
          })
          .catch(function (res) {
            console.log("query user fail", res);
          });
      }
    },
    putPrice() {
      let that = this;
      let length = that.choosedItems.length;
      let item = {};
      if (length === 1) {
        that.onModifyClick();
      } else if (length === 0) {
        that.findNoPrice();
      }
    },
    showCixinEstate() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.dblist.filter((x) => x.cixin);
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    onExpectedClick() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.dblist.filter((x) => x.noEx);
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    findFinish() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.dblist.filter((x) => x.knsq);
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    checkImportant() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.baseList.filter((x) => x.location_degree === "重点");
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },
    checkSize() {
      this.page = 1;
      this.showdblist = [];
      this.search();
      this.baseList = this.baseList.filter((x) =>
        this.gmCheck ? x.location_size : !x.location_size
      );
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
      this.gmCheck = !this.gmCheck;
    },

    onLevelClick() {
      let that = this;
      if (!that.currentModel.includes("EstateModel")) {
        return false;
      }
      if (this.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        that.$axios
          .get(that.$url_prefix + "updateLocationLevelAndLabel", {
            params: {
              real_estate_id: item.id,
            },
          })
          .then(function (res) {
            console.log("更新等级返回", res);
          })
          .catch(function (res) {
            console.log("计算等级失败", res);
          });
      } else if (this.choosedItems.length === 0) {
        this.confirmOption = {
          title: "注意注意！",
          words: "确定要更新所有楼盘的地段等级和标签吗？",
          okWord: "确定",
          cancleWord: "取消",
          to: "updateLabel",
        };
        this.isconfirmshow = true;
      }
    },
    updateAllLabel() {
      this.isconfirmshow = false;
      let that = this;
      let type = "新房";
      if (that.currentModel === "WpRealEstateModel2") {
        type = "二手房";
      }
      that.$axios
        .get(that.$url_prefix + "updateLocationLevelAndLabel", {
          params: {
            real_estate_id: "全部",
            type: type,
          },
        })
        .then(function (res) {
          console.log("更新等级返回", res);
        })
        .catch(function (res) {
          console.log("计算等级失败", res);
        });
    },
    noChoose() {
      this.$refs.multipleTable.clearSelection();
    },

    onMapDeleteClick() {
      let that = this;
      if (this.choosedItems.length === 1) {
        if (that.currentModel === "WpLocationModel") {
          let item = that.choosedItems[0];
          if (item.location_name && item.lnglat) {
            this.$axios
              .post(that.$url_prefix + "delete", {
                db: that.currentModel,
                items: JSON.stringify([item]),
              })
              .then(function (response) {
                that.onFlashClick();
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        }
      }
    },

    toAdUpAndDown() {
      let that = this;
      let list = that.choosedItems;
      if (list.length === 0) {
        return;
      }
      let tip = `确定要改变这${list.length}条的上架状态吗？`;
      that
        .$confirm(tip, "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.adUpAndDown(list);
        })
        .catch(() => {
          console.log("取消修改");
        });
    },
    adUpAndDown(list) {
      let that = this;
      that.$open();
      let listParam = [];
      list.forEach((x) => {
        listParam.push(x.id);
      });
      that.$axios
        .post(that.$url_prefix + "adUpAndDown", {
          ads: listParam,
        })
        .then(function (res) {
          console.log("ad up and down back", res);
          that.init();
        })
        .catch(function (res) {
          console.log("ad up and down fail", res);
        });
    },

    navigateTo(name) {
      // 画地块、画板块、画学区
      if (this.choosedItems.length === 1) {
        let item = this.choosedItems[0];
        this.$router.push({
          name: name,
          params: item,
        });
      }
    },

    setWait() {
      let that = this;
      let list = JSON.parse(JSON.stringify(that.choosedItems));
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let obj = {
            id: list[i].id,
            status: "待定",
          };
          let param = {
            db: "WpLocationModel",
            model: "edit",
            item: JSON.stringify(obj),
          };
          that.$axios
            .post(that.$url_prefix + "updateData", param)
            .then(function (res) {
              console.log("上传", res);
            })
            .catch(function (res) {
              console.log("上传失败", res);
            });
        }
      }
    },

    checkInvite() {
      let that = this;
      if (that.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        that.$axios
          .get(that.$url_prefix + "checkInvite", {
            params: {
              user_id: item.id,
            },
          })
          .then(function (res) {
            console.log("invite", res);
            // console.log('form', JSON.parse(res.data.data.form_id));
          })
          .catch(function (res) {
            console.log("query invite fail", res);
          });
      }
    },

    getSpaceCode() {
      let that = this;
      if (that.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        that.$axios
          .get(that.$url_prefix + "getSpaceCode", {
            params: {
              user_id: item.id,
            },
          })
          .then(function (res) {
            console.log("res", res);
            if (res.data.success) {
              that.spaceCode = res.data.data;
            }
          })
          .catch(function (res) {
            console.log("query invite fail", res);
          });
      }
    },
    getMpCode(page) {
      let that = this;
      if (page && that.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        that.$axios
          .get(that.$url_prefix + "getMpCode", {
            params: {
              toPage: page,
              id: item.id,
            },
          })
          .then(function (res) {
            console.log("res", res);
            if (res.data.success) {
              that.spaceCode = res.data.data;
            }
          })
          .catch(function (res) {
            console.log("query invite fail", res);
          });
      }
    },
    sendSystemMessage() {
      let that = this;
      if (that.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        that.$router.push({
          name: "system",
          params: {
            user_id: item.id,
            user_name: item.user_name,
          },
        });
      }
    },

    sortDataList(key) {
      let that = this;
      let status = ["在售", "待首开"];
      if (that.sortMap.hasOwnProperty(key)) {
        if (this.currentModel === "WpRealEstateModel") {
          if (that.sortMap[key]) {
            // 升序
            that.baseList.sort((a, b) => {
              let numa = 1000000;
              let numb = 1000000;
              if (status.includes(a.real_status)) {
                if (a[key] || a[key] === 0) {
                  numa = a[key];
                }
              }
              if (status.includes(b.real_status)) {
                if (b[key] || b[key] === 0) {
                  numb = b[key];
                }
              }
              return numa - numb;
            });
          } else {
            // 降序
            that.baseList.sort((a, b) => {
              let numa = -1;
              let numb = -1;
              if (status.includes(a.real_status)) {
                if (a[key] || a[key] === 0) {
                  numa = a[key];
                }
              }
              if (status.includes(b.real_status)) {
                if (b[key] || b[key] === 0) {
                  numb = b[key];
                }
              }
              return numb - numa;
            });
          }
        } else if (
          [
            "SzUserModel",
            "WpUserModel",
            "SxUserModel",
            "NbUserModel",
            "TjUserModel",
            "WpLocationModel",
            "SzLocationModel",
            "TjLocationModel",
            "SxLocationModel",
            "NbLocationModel",
            "WpAreaModel",
            "SzAreaModel",
            "TjAreaModel",
            "SxAreaModel",
            "NbAreaModel",
          ].includes(this.currentModel)
        ) {
          if (that.sortMap[key]) {
            // 升序
            that.baseList.sort((a, b) => {
              let numa = 1000000;
              let numb = 1000000;
              if (a[key] || a[key] === 0) {
                numa = a[key];
              }
              if (b[key] || b[key] === 0) {
                numb = b[key];
              }
              return numa - numb;
            });
          } else {
            // 降序
            that.baseList.sort((a, b) => {
              let numa = -1;
              let numb = -1;
              if (a[key] || a[key] === 0) {
                numa = a[key];
              }
              if (b[key] || b[key] === 0) {
                numb = b[key];
              }
              return numb - numa;
            });
          }
        }

        that.sortMap[key] = !that.sortMap[key];
        that.page = 1;
        that.showdblist = JSON.parse(JSON.stringify(that.baseList)).slice(
          (that.page - 1) * 40,
          that.page * 40
        );
      }
    },

    findWaitCopy() {
      this.page = 1;
      this.showdblist = [];
      this.baseList = this.dblist.filter(
        (x) => !x.bind_old && x.real_status === "售罄"
      );
      this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(0, 40);
    },

    handleSelectionChange(val) {
      this.choosedItems = val;
    },
    // 选择某个表
    onMenuSelect(index) {
      let arr = index.split("-");
      let model = this.menulist[arr[1]];
      console.log("model", model);
      if (model && model !== this.currentModel) {
        this.currentModel = model;
        this.activityPeopleType = "全部";
        this.$open();
        let thiz = this;
        let data = {
          dataContent: model,
        };
        this.page = 1;
        this.$axios
          .get(thiz.$url_prefix + "getDataByModel", {
            params: data,
          })
          .then(function (response) {
            console.log(model, response.data.data);
            let tempList = response.data.data;
            thiz.dblist = tempList;
            thiz.baseList = JSON.parse(JSON.stringify(tempList));
            thiz.showdblist = JSON.parse(JSON.stringify(tempList)).slice(
              (thiz.page - 1) * 40,
              thiz.page * 40
            );
            thiz.$close();
          })
          .catch(function (error) {
            thiz.$close();
            thiz.dblist = [];
            thiz.showdblist = [];
            thiz.baseList = [];
          });
      }
    },
    onRowClick(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    headerCellStyle() {
      return {
        "background-color": "rgb(82, 82, 82)",
        border: "none",
        "font-size": "16px",
        color: "#c8c8c8",
      };
    },
    cellStyle({ rowIndex }) {
      let obj = {
        "background-color": "rgb(61,61,61)",
        "font-size": "16px",
        color: "#c8c8c8",
        border: "none",
      };
      if (rowIndex % 2 === 0) {
        obj["background-color"] = "rgb(53,53,53)";
      } else {
        obj["background-color"] = "rgb(61,61,61)";
      }
      return obj;
    },
    cellMouseEnter(row, column, cell, event) {
      let parent = event.target.parentNode;
      let cells = parent.children;
      for (let i = 0; i < cells.length; i++) {
        cells[i].style.backgroundColor = "rgb(82, 82, 82)";
      }
    },
    cellMouseLeave(row, column, cell, event) {
      let index = this.showdblist.findIndex((x) => x._id === row._id);
      let bg = "rgb(61,61,61)";
      if (index % 2 === 0) {
        bg = "rgb(53,53,53)";
      }
      let parent = event.target.parentNode;
      let cells = parent.children;
      for (let i = 0; i < cells.length; i++) {
        cells[i].style.backgroundColor = bg;
      }
    },

    putArt(id) {
      let that = this;
      if (that.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        that.$axios
          .get(that.$url_prefix + "putArtice", {
            params: {
              id: item.id,
            },
          })
          .then((res) => {
            console.log("res", res.data);
            if (res.data.success) {
              that.$message({
                type: "success",
                message: "投放成功",
              });
            } else {
              that.$message.error(res.data.msg);
            }
          });
      }
    },

    getErrSub() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getErrSub")
        .then((res) => {
          console.log("res.", res);
          this.page = 1;
          this.showdblist = [];
          this.baseList = res.data.data;
          this.showdblist = JSON.parse(JSON.stringify(this.baseList)).slice(
            0,
            40
          );
          that.$close();
        })
        .catch((err) => {
          that.$close();
          console.log("err", err);
        });
    },

    onModelMenuClick(omenu) {
      console.log("omenu", omenu);
      switch (omenu) {
        case "附近":
          this.onNearbyClick();
          break;
        case "等级":
          this.onLevelClick();
          break;
        case "公示":
          this.onSaleInfoClick("公示");
          break;
        case "图库":
          this.onSaleInfoClick("图库");
          break;
        case "详情":
          if (this.currentModel.includes("UserModel")) {
            this.getUser();
          } else {
            this.onInfoClick();
          }
          break;
        case "价格":
          this.putPrice();
          break;
        case "预约码":
          this.getMpCode("预约报名");
          break;
        case "次新":
          this.showCixinEstate();
          break;
        case "预计":
          this.onExpectedClick();
          break;
        case "售罄":
          this.findFinish();
          break;
        case "复制":
          this.findWaitCopy();
          break;
        case "上下架":
          this.toAdUpAndDown();
          break;
        case "画地块":
          this.navigateTo("drawLand");
          break;
        case "画板块":
          this.navigateTo("drawArea");
          break;
        case "更新地块":
          this.updateAreaLandPlan();
          break;
        case "画学区":
          this.navigateTo("schoolDistrict");
          break;
        case "重点":
          this.checkImportant();
          break;
        case "配套图":
          this.onSaleInfoClick("配套图库");
          break;
        case "规模":
          this.checkSize();
          break;
        case "空间码":
          this.getSpaceCode();
          break;
        case "消息":
          this.sendSystemMessage();
          break;
        case "坐标":
          this.findNoLnglat();
          break;
        case "限价":
          this.findNoLimitj();
          break;
        case "开发商":
          this.findNoDevelop();
          break;
        case "未建盘":
          this.findNoEstate();
          break;
        case "写文章":
          this.toEditArticle();
          break;
        case "扫码":
          if (this.currentModel.includes("Article")) {
            this.getMpCode("文章");
          } else if (this.currentModel.includes("Crlist")) {
            this.getMpCode("合集详情");
          }
          break;
        case "投放群":
          this.putArt();
          break;
        case "地铁":
          this.getErrSub();
          break;
        case "群截图":
          this.toScreenShot();
          break;
        case "置顶":
          this.toTop();
          break;
        case "清空活动":
          this.clearGameData();
          break;
      }
    },

    async clearGameData() {
      try {
        for (let item of this.choosedItems) {
          await this.$axios.post(this.$url_prefix + "games/clear", {
            user_id: item.id,
          });
        }
        this.$message({
          type: "success",
          message: "成功",
        });
      } catch (err) {
        this.$message.error("失败");
      }
    },

    toScreenShot() {
      let that = this;
      if (that.choosedItems.length === 1) {
        let item = that.choosedItems[0];
        let obj = {
          id: "1noo4befhxr",
          data: item.id,
        };
        let param = {
          db: "WpBackupModel",
          model: "edit",
          item: JSON.stringify(obj),
        };
        that.$axios
          .post(that.$url_prefix + "updateData", param)
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: "success",
                message: "投放成功",
              });
            } else {
              that.$message.error(res.data.msg);
            }
          })
          .catch(function (res) {
            that.$message.error("投放失败");
          });
      }
    },

    toTop() {
      let that = this;
      if (that.choosedItems.length === 1) {
        let data = that.choosedItems[0];
        let creat = data.create_time.split("-");
        let arr = data.sort_time.split("-");
        let diff = parseInt(arr[0]) - parseInt(creat[0]);
        let sort_time;
        if (diff > 0) {
          // 取消
          sort_time = parseInt(creat[0]) + "-" + arr[1] + "-" + arr[2];
        } else {
          sort_time = parseInt(creat[0]) + 200 + "-" + arr[1] + "-" + arr[2];
        }
        let obj = {
          id: data.id,
          sort_time: sort_time,
        };
        let param = {
          db: "WpArticleModel",
          model: "edit",
          item: JSON.stringify(obj),
        };
        that.$axios
          .post(that.$url_prefix + "updateData", param)
          .then(function (res) {
            data.sort_time = sort_time;
            that.$message({
              type: "success",
              message: diff > 0 ? "已取消置顶" : "置顶成功",
            });
          })
          .catch(function (res) {
            that.$message.error("操作失败");
          });
      }
    },

    updateAreaLandPlan() {
      if (this.choosedItems.length === 1) {
        let item = this.choosedItems[0];
        this.$axios
          .get(this.$url_prefix + "updateAreaLandPlan", {
            params: {
              area_id: item.id,
            },
          })
          .then((res) => {
            this.$message({
              type: "success",
              message: "已更新，稍后查看",
            });
          });
      }
    },
    heightNotZero(arr) {
      let num = -1;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== 0) {
          num++;
        }
      }
      return num;
    },
    splitByPixelWidth(ctx, text, maxWidth) {
      let lines = [];
      let currentLine = "";
      for (let char of text) {
        let testLine = currentLine + char;
        ctx.font = "normal 28px sans-serif";
        let testWidth = ctx.measureText(testLine).width;
        if (testWidth > maxWidth) {
          lines.push(currentLine);
          currentLine = char;
        } else {
          currentLine = testLine;
        }
      }
      if (currentLine) lines.push(currentLine);
      return lines;
    },
    drawActivityPoster() {
      if (this.choosedItems.length === 1) {
        let item = this.choosedItems[0];
        let canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = 750;
        let top = 315;
        let padding = 20;
        let heights = [0, 0, 0, 0];
        let content = item.type == "文章" ? item.articleTitle : item.type;
        let share = item.share ? item.share.replace(/\n/g, " ") : "";
        share = "分享文案：" + share;
        let contentList1 = this.splitByPixelWidth(ctx, content, 670);
        let contentList2 = this.splitByPixelWidth(ctx, share, 670);

        let lines1 = contentList1.length + contentList2.length;
        heights[0] = lines1 ? lines1 * 42 + 72 + 30 : 0;
        let words = item.words ? item.words.replace(/\n/g, " ") : "";
        let wordsList = this.splitByPixelWidth(ctx, words, 670);
        let lines2 = wordsList.length;
        heights[1] = lines2 ? lines2 * 42 + 72 + 20 + 60 : 0;
        let awards = item.award ? item.award.replace(/\n/g, " ") : "";
        let awardsList = this.splitByPixelWidth(ctx, awards, 670);
        let lines3 = awardsList.length;
        heights[2] = lines3 ? lines3 * 42 + 72 + 20 : 0;
        let timeList = [
          "开始时间：" + item.starttime,
          "截止时间：" + item.deadline,
        ];
        let lines4 = 2;
        heights[3] = lines4 * 42 + 72 + 20;
        console.log("contentList1", contentList1);
        console.log("contentList2", contentList2);
        console.log("wordsList", wordsList);
        console.log("awardsList", awardsList);

        let contentH = heights[0] + heights[1] + heights[2] + heights[3];
        canvas.height =
          top + contentH + padding * this.heightNotZero(heights) + 30;

        this.drawRoundedRect(
          ctx,
          0,
          0,
          canvas.width,
          canvas.height,
          0,
          "#FFF47E"
        );
        let bg = new Image();
        if (item.timing) {
          bg.src = "/static/images/limit_activity_top.png";
        } else {
          bg.src = "/static/images/double_activity_top.png";
        }
        bg.onload = () => {
          ctx.drawImage(bg, 0, 0, canvas.width, 484);
          this.drawRoundedRect(ctx, 20, top, canvas.width - 40, heights[0], 20);
          let img1 = new Image();
          img1.src = "/static/images/double_activity_t1.png";
          img1.onload = () => {
            ctx.drawImage(img1, (canvas.width - 326) / 2, top, 326, 52);
            let img2 = new Image();
            img2.src = "/static/images/double_activity_t2.png";
            img2.onload = () => {
              ctx.fillStyle = "#333333";
              ctx.font = "bold 32px sans-serif";
              ctx.textBaseline = "top";
              let txtWidth = ctx.measureText("转发内容参与活动").width;
              ctx.fillText(
                "转发内容参与活动",
                (canvas.width - txtWidth) / 2,
                top + 9
              );
              let top1 = top + 72;
              ctx.font = "normal 28px sans-serif";
              if (contentList1.length > 0) {
                for (let i = 0; i < contentList1.length; i++) {
                  ctx.fillText(contentList1[i], 50, top1);
                  // 画下划线
                  const textWidth = ctx.measureText(contentList1[i]).width;
                  const underlineY = top1 + 28; // 28为字体大小，可微调
                  ctx.beginPath();
                  ctx.moveTo(50, underlineY);
                  ctx.lineTo(50 + textWidth, underlineY);
                  ctx.lineWidth = 1.5;
                  ctx.strokeStyle = "#333333";
                  ctx.stroke();
                  top1 = top1 + 42;
                }
              }
              top1 = top1 + 10;
              if (contentList2.length > 0) {
                for (let i = 0; i < contentList2.length; i++) {
                  ctx.fillText(contentList2[i], 50, top1);
                  top1 = top1 + 42;
                }
              }
              top = top + heights[0] + padding;
              if (words) {
                this.drawRoundedRect(
                  ctx,
                  20,
                  top,
                  canvas.width - 40,
                  heights[1],
                  20
                );
                ctx.drawImage(img2, (canvas.width - 216) / 2, top, 216, 52);
                ctx.font = "bold 32px sans-serif";
                txtWidth = ctx.measureText("活动规则").width;
                ctx.fillText(
                  "活动规则",
                  (canvas.width - txtWidth) / 2,
                  top + 9
                );
                top1 = top + 72;
                ctx.font = "normal 28px sans-serif";
                if (wordsList.length > 0) {
                  for (let i = 0; i < wordsList.length; i++) {
                    ctx.fillText(wordsList[i], 50, top1);
                    top1 = top1 + 42;
                  }
                }

                ctx.fillStyle = "#999999";
                ctx.font = "normal 24px sans-serif";
                const prefix = "遇到问题?添加客服微信";
                const weixin = item.weixin || "";
                const baseY = top1 + 30;
                const baseX = 50;
                // 先画前缀
                ctx.fillText(prefix, baseX, baseY);
                // 计算前缀宽度
                const prefixWidth = ctx.measureText(prefix).width;
                // 再画微信号
                ctx.fillText(weixin, baseX + prefixWidth, baseY);
                // 画下划线
                const weixinWidth = ctx.measureText(weixin).width;
                const underlineY = baseY + 24; // 24为字体大小
                ctx.beginPath();
                ctx.moveTo(baseX + prefixWidth, underlineY);
                ctx.lineTo(baseX + prefixWidth + weixinWidth, underlineY);
                ctx.lineWidth = 1;
                ctx.stroke();
                ctx.fillStyle = "#333333";
                top = top + heights[1] + padding;
              }
              if (awards) {
                this.drawRoundedRect(
                  ctx,
                  20,
                  top,
                  canvas.width - 40,
                  heights[2],
                  20
                );
                ctx.drawImage(img2, (canvas.width - 216) / 2, top, 216, 52);
                ctx.font = "bold 32px sans-serif";
                txtWidth = ctx.measureText("活动奖励").width;
                ctx.fillText(
                  "活动奖励",
                  (canvas.width - txtWidth) / 2,
                  top + 9
                );
                top1 = top + 72;
                ctx.font = "normal 28px sans-serif";
                if (awardsList.length > 0) {
                  for (let i = 0; i < awardsList.length; i++) {
                    ctx.fillText(awardsList[i], 50, top1);
                    top1 = top1 + 42;
                  }
                }
                top = top + heights[2] + padding;
              }

              this.drawRoundedRect(
                ctx,
                20,
                top,
                canvas.width - 40,
                heights[3],
                20
              );
              ctx.drawImage(img2, (canvas.width - 216) / 2, top, 216, 52);
              ctx.font = "bold 32px sans-serif";
              txtWidth = ctx.measureText("活动时间").width;
              ctx.fillText("活动时间", (canvas.width - txtWidth) / 2, top + 9);
              top1 = top + 72;
              ctx.font = "normal 28px sans-serif";
              if (timeList.length > 0) {
                for (let i = 0; i < timeList.length; i++) {
                  ctx.fillText(timeList[i], 50, top1);
                  top1 = top1 + 42;
                }
              }
              this.activityPoster = canvas.toDataURL("image/png");
              this.$message.success("海报生成成功！");
            };
          };
        };
      } else {
        this.$message.error("请选择一个活动");
      }
    },
    //白色圆角矩形
    drawRoundedRect(ctx, x, y, width, height, radius, fillColor) {
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      ctx.lineTo(x + width, y + height - radius);
      ctx.quadraticCurveTo(
        x + width,
        y + height,
        x + width - radius,
        y + height
      );
      ctx.lineTo(x + radius, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
      ctx.closePath();
      ctx.fillStyle = fillColor || "#ffffff";
      ctx.fill();
      ctx.restore();
    },
  },
};
</script>

<style scoped>
.indexPage {
  overflow: hidden;
  background-color: #545c64;
}

.top-bar {
  display: flex;
  /* height: 40px; */
  position: fixed;
  z-index: 2;
  /* overflow: hidden; */
  background-color: #ccc;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
}

.top-bar .search-box {
  height: 40px;
  box-sizing: border-box;
  border: 1px solid black;
  margin-left: 5px;
}

.top-bar input {
  outline: none;
  border: none;
  height: 100%;
}

.top-bar .tool-item {
  height: 40px;
  line-height: 40px;
  text-align: center;
  box-sizing: border-box;
  margin-left: 5px;
  border: 1px solid black;
  padding: 0 10px;
  cursor: pointer;
}

.top-bar .tool-items {
  height: 40px;
  line-height: 40px;
  text-align: center;
  box-sizing: border-box;
  margin-left: 5px;
  border: 1px solid black;
  background-color: #474747;
  color: white;
  padding: 0 10px;
  cursor: pointer;
}

.data-base-content {
  margin-top: 40px;
}

.count {
  height: 40px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.image-background {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(169, 169, 169, 0.8);
  z-index: 8;
  text-align: center;
}

.image-preview {
  margin-top: 200px;
  background-color: #fff;
  text-align: center;
  border: 1px solid #865ea7;
  padding: 10px;
  display: inline-block;
  position: relative;
}

.close {
  padding: 5px;
  position: absolute;
  top: 0;
  right: 0;
  background-color: red;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/page/IndexPage.vue